import { Col, Row } from 'antd'
import { SkeletonItem } from 'components/Skeleton'
import { useTheme } from 'styled-components'

const ListItem = () => (
	<Col span="12">
		<SkeletonItem $height={36} />
	</Col>
)

const TransferMappingSkeleton = () => {
	const theme = useTheme()

	return (
		<Row gutter={[theme.margins.sm, theme.margins.sm]}>
			<ListItem />
			<ListItem />
			<ListItem />
			<ListItem />
			<ListItem />
			<ListItem />
			<ListItem />
			<ListItem />
		</Row>
	)
}

export default TransferMappingSkeleton
